
<template>
  <el-dialog width="520px"
             v-dialog-drag
             title="关联展项"
             :before-close="handleClickCancel"
             :close-on-press-escape="false"
             :close-on-click-modal="false"
             :visible.sync="associationExhibitionItemVisible">
    <el-form size="small"
             ref="associationExhibitionForm"
             label-position="top"
             label-width="185px"
             :model="associationExhibitionForm"
             :rules="associationExhibitionFormRules" v-loading="loading">
      <el-form-item label="选择关联展项" prop="id">
        <el-select @change="handleChangeSelect" key="userid"  filterable placeholder="请选择" ref="mySelect3"  remote reserve-keyword  v-model="associationExhibitionForm.id">
          <el-option  v-for="(item,index) in exhibitionList" :key="item.id"   :label="item.title"   :value="item.id" :disabled="disabledIds.indexOf(item.id) > -1"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button size="small"   :disabled="btnDisabled" @click="handleClickConfirm" type="primary">确定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {  exhibitionProjectList } from "@/api";
import {mapState} from "vuex";

export default {
  name: "association_exhibition_items",
  props: {
    associationExhibitionItemVisible: {
      type: Boolean,
      default: false,
    },
    hallId: {
      type: Number,
      default: 0,
    },
    disabledIds: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      loading: false,
      btnDisabled: false,
      associationExhibitionForm: {
        id: '',
        cover_image:''
      },
      associationExhibitionFormRules: {
        id: [{required: true, message: '请选择关联的展项', trigger: 'change'},],

      },
      exhibitionList:[]
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  created() {
    console.log(this.hallId);
    if(this.hallId != 0){
      this.associationExhibitionForm.id = this.hallId
    }
    this.getExhibitionList()
  },
  mounted() {
  },
  methods: {
    getExhibitionList() {
      this.loading = true
      exhibitionProjectList({
        company_id:(this.userInfo && this.userInfo.company_id)  ? this.userInfo.company_id :'',
      }).then(res => {
        if (res.code === 200) {
          const { data, } = res
          this.exhibitionList = data
        }
        this.loading = false
      })
    },

    handleClickCancel() {
      this.$refs.associationExhibitionForm.resetFields()
      this.$emit('update:associationExhibitionItemVisible', false)
    },
    handleChangeSelect(val){
      let info = this.exhibitionList.find(find => val == find.id )
      if(info){
        this.$set(this.associationExhibitionForm,'cover_image',info.cover_image)
        this.$set(this.associationExhibitionForm,'title',info.title)
      }
      // cover_image
    },
    handleClickConfirm() {
      this.$refs.associationExhibitionForm.validate(valid => {
        if (valid) {
          this.btnDisabled = true
          this.$message.success('关联成功')
          this.$emit('success',this.associationExhibitionForm)
          this.$emit('update:associationExhibitionItemVisible', false)
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.el-date-editor.el-input {
  width: 100%;
}
</style>
